import React, { Component } from 'react';

export default class Categorias extends Component {
    render(){
        return (
            <div className="Categorias">
                <div className="container flex horizontal-only">
                    <div className="flex-1 flex flex-center categoria">
                        <span className="text-center">Informática</span>
                    </div>
                    <div className="flex-1 flex flex-center categoria">
                        <span className="text-center">Telefonia</span>
                    </div>
                    <div className="flex-1 flex flex-center categoria">
                        <span className="text-center">Automotivo</span>
                    </div>
                    <div className="flex-1 flex flex-center categoria">
                        <span className="text-center">Eletro Eletronica</span>
                    </div>
                </div>
            </div>
        )
    }
}